import { api } from '../api';
import type { MenuCategory } from '@/types/menu-category';

export interface CreateMenuCategoryInput {
  companyId: number;
  name: string;
}

export interface ReorderMenuCategoriesInput {
  companyId: number;
  /** Category ids of that concept, in the wanted order. */
  orderedIds: number[];
}

// skipToast: these mutations surface the server message through their own
// onError handlers, so the client's generic auto-toast would double up.
export const menuCategoryRequests = {
  /** A concept's categories in their saved order. */
  list: (companyId: number) =>
    api.get<MenuCategory[]>(`/menu-categories?companyId=${companyId}`),

  create: (data: CreateMenuCategoryInput) =>
    api.post<MenuCategory>('/menu-categories', data, { skipToast: true }),

  /** Menu items on the category follow the new name. */
  rename: (id: number, name: string) =>
    api.patch<MenuCategory>(`/menu-categories/${id}`, { name }, { skipToast: true }),

  reorder: (data: ReorderMenuCategoriesInput) =>
    api.put<MenuCategory[]>('/menu-categories/reorder', data, { skipToast: true }),

  /**
   * A category with menu items needs `reassignToId`, another category of the
   * same concept that receives them. Without it the API refuses.
   */
  remove: (id: number, reassignToId?: number) =>
    api.delete<{ deleted: true; reassignedItems: number }>(
      `/menu-categories/${id}${reassignToId != null ? `?reassignToId=${reassignToId}` : ''}`,
      { skipToast: true },
    ),
};
